export type Tempo = number

export const tempoToString = (tempo?: Tempo) => (tempo ? `${tempo} BPM` : null)
